module.exports = __webpack_public_path__ + "static/media/karta_vespa1.b923b31a.png";